import type { ChatSource } from "@mirage/mosaics/Chat/types";
import { atom, useAtom } from "jotai";

const manuallyAddedSourcesAtom = atom<ChatSource[]>([]);
export const useManuallyAddedSources = () => {
  const [manuallyAddedSources, setManuallyAddedSources] = useAtom(
    manuallyAddedSourcesAtom,
  );
  return {
    manuallyAddedSources,
    setManuallyAddedSources,
  };
};
